module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('my-menu', {
    attrs: {
      "menu-name": "home"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "banner"
  }, [_c('img', {
    staticClass: "bg",
    attrs: {
      "src": require("../assets/images/teacher-header.png")
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "wrapper"
  }, [_c('div', {
    staticClass: "switch"
  }, [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_vm._v("教师端")]), _vm._v(" "), _c('router-link', {
    staticClass: "switch-active",
    attrs: {
      "to": "/student"
    }
  }, [_vm._v("学生端")])], 1), _vm._v(" "), _c('div', {
    staticClass: "inner"
  }, [_c('p', {
    staticClass: "text_weici"
  }, [_vm._v("维词教师版")]), _vm._v(" "), _c('p', {
    staticClass: "text_slogan"
  }, [_vm._v("让你的英语教学更精彩")]), _vm._v(" "), _c('div', {
    staticClass: "product_list"
  }, [_c('div', {
    staticClass: "product_item"
  }, [_c('div', {
    staticClass: "product-content",
    on: {
      "click": function($event) {
        return _vm.showDownloadHandle('old')
      }
    }
  }, [_c('img', {
    staticClass: "product_icon",
    attrs: {
      "src": require("../assets/images/old_sys_icon.png")
    }
  }), _vm._v(" "), _vm._m(0)])]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "product_item"
  }, [_c('div', {
    staticClass: "product-content",
    on: {
      "click": function($event) {
        return _vm.showDownloadHandle('new')
      }
    }
  }, [_c('img', {
    staticClass: "product_icon",
    attrs: {
      "src": require("../assets/images/new_sys_icon.png")
    }
  }), _vm._v(" "), _vm._m(2)])])])]), _vm._v(" "), _vm._m(3)])]), _vm._v(" "), _c('section', {
    staticClass: "content"
  }, [_vm._m(4), _vm._v(" "), _vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_c('ul', [_c('li', [_vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "img_right"
  }, [_c('img', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy",
      value: ('/static/images/home/5.png'),
      expression: "'/static/images/home/5.png'"
    }]
  })])]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "img_left"
  }, [_c('img', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy",
      value: ('/static/images/home/6.png'),
      expression: "'/static/images/home/6.png'"
    }]
  })]), _vm._v(" "), _vm._m(7)]), _vm._v(" "), _c('li', [_vm._m(8), _vm._v(" "), _c('div', {
    staticClass: "img_right"
  }, [_c('img', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy",
      value: ('/static/images/home/7.png'),
      expression: "'/static/images/home/7.png'"
    }]
  })])])])])]), _vm._v(" "), _c('my-footer'), _vm._v(" "), _c('Download', {
    attrs: {
      "show": _vm.downloadShow
    },
    on: {
      "update:show": function($event) {
        _vm.downloadShow = $event
      },
      "download": _vm.downloadNowHandle
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "product_des"
  }, [_c('p', [_vm._v("点击下载")]), _vm._v(" "), _c('p', [_vm._v("《高中维词教学系统》")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "product_item"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/images/mqrcodes.png")
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "product_des"
  }, [_c('p', [_vm._v("扫码下载")]), _vm._v(" "), _c('p', [_vm._v("高中维词教师版")]), _vm._v(" "), _c('p', [_vm._v("APP移动端")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "product_des"
  }, [_c('p', [_vm._v("点击下载")]), _vm._v(" "), _c('p', [_vm._v("《维词数智化教学平台》")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "download"
  }, [_c('a', {
    attrs: {
      "href": "https://itunes.apple.com/cn/app/%E7%BB%B4%E8%AF%8D%E6%95%99%E5%B8%88%E7%89%88/id1354318280?mt=8",
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/images/ios.png")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "line"
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "http://a.app.qq.com/o/simple.jsp?pkgname=com.android.weici.senior.teacher",
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/images/ad.png")
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text"
  }, [_c('p', [_vm._v("维词教师版是一款")]), _vm._v(" "), _c('p', [_vm._v("为高中英语老师精心准备的教学辅助工具")]), _vm._v(" "), _c('p', [_vm._v("内容融入英语教学各个场景 为学生英语学习提供帮助")]), _vm._v(" "), _c('p', [_vm._v("WEICI App (Teacher's Edition) ")]), _vm._v(" "), _c('p', [_vm._v("is specially designed as an effective tool")]), _vm._v(" "), _c('p', [_vm._v("for High School English teachers to help their students improve scores.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "arrow"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/images/arrow.png")
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card_text"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v("精选优质内容")]), _vm._v(" "), _c('p', {
    staticClass: "title"
  }, [_vm._v("给老师赋能")]), _vm._v(" "), _c('p', [_vm._v("大数据标注历年考点，多维度精讲词汇")]), _vm._v(" "), _c('p', [_vm._v("专业教学设计，精准同步教材")]), _vm._v(" "), _c('p', [_vm._v("优质课件、影音词汇讲解，备课资源丰富 ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card_text right"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v("智能分析")]), _vm._v(" "), _c('p', {
    staticClass: "title"
  }, [_vm._v("帮学生查漏补缺")]), _vm._v(" "), _c('p', [_vm._v("精选题库、多种题型，一键布置作业")]), _vm._v(" "), _c('p', [_vm._v("大数据智能分析，检查作业更轻松")]), _vm._v(" "), _c('p', [_vm._v("分层教学，真正实现因材施教")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card_text"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v("融入教学场景")]), _vm._v(" "), _c('p', {
    staticClass: "title"
  }, [_vm._v("为老师赋能")]), _vm._v(" "), _c('p', [_vm._v("课前预习，讲课更轻松")]), _vm._v(" "), _c('p', [_vm._v("课上多种教学方式，激发学生英语学习兴趣")]), _vm._v(" "), _c('p', [_vm._v("课后巩固、查漏补缺，培养学生好习惯")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0734a327","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Teacher.vue
// module id = 87
// module chunks = 0